import React from 'react'
import {Text,Box,NameValueList,NameValuePair} from 'grommet'
import {User,MailOption,Phone,Organization,MapLocation,Location} from 'grommet-icons';
import Flag from 'react-world-flags'
import { PostalCodeRequired } from './utils/shared/shared';

const returnAddressDetails = (props) => {
    const lab = props.lab
    const postCodeRequired = PostalCodeRequired(lab.country.CountryCode)
    if (lab.name.includes('Select')){
        return (
            null
        )
    } else {
        return(
            <Box pad='small'>
             <NameValueList margin='small'>
            <NameValuePair name={<Box direction='row'><Organization color='brand' /><Text margin={{left: 'xsmall'}} size='small' weight={'bold'}>Company Name</Text></Box>} icon={<Organization />}>
              <Text size='small'>{lab.contact.companyName}</Text>
            </NameValuePair>
            <NameValuePair name={<Box direction='row'><MapLocation color='brand'/><Text margin={{left: 'xsmall'}} size='small' weight={'bold'}>Address</Text></Box>}>
            {(lab.hasOwnProperty("address_line_two") && lab.address_line_two !== ''  ? <Text size='small'>{lab.address_line_one} ,</Text> : <Text size='small'>{lab.address_line_one}</Text>)}
            {(lab.hasOwnProperty("address_line_two") && lab.address_line_two !== '' ? <Text size='small'>{lab.address_line_two}</Text> : null)}{(lab.hasOwnProperty('address_line_three') && lab.address_line_three !== '' ? <Text size='small'>, {lab.address_line_three}</Text>: null)}
            </NameValuePair>
            <NameValuePair name={<Box direction='row'><Location color='brand'/><Text margin={{left: 'xsmall'}} size='small' weight={'bold'}>City</Text></Box>}>
            <Text size='small'>{lab.city}</Text>
            </NameValuePair>
            {(postCodeRequired && 
                <NameValuePair name={<Box direction='row'><Location color='brand'/><Text margin={{left: 'xsmall'}} size='small' weight={'bold'}>Postal Code</Text></Box>}>
                <Text size='small'>{lab.postcode}</Text>
                </NameValuePair>
            )}
            <NameValuePair name={<Box direction='row'><Location color='brand'/><Text margin={{left: 'xsmall'}} size='small' weight={'bold'}>Country</Text></Box>}>
            <Box direction='row'><Text size='small' >{lab.country.CountryName}</Text><Flag style={{marginTop: 1, marginLeft: 15}}height='20' code={lab.country.CountryCode} fallback={ <Text size='xsmall'>Unknown</Text> }/></Box>
            </NameValuePair>
            <NameValuePair name={<Box direction='row'><User color='brand'/><Text margin={{left: 'xsmall'}} size='small' weight={'bold'}>Contact Name</Text></Box>}>
            <Text size='small'>{lab.contact.contactName}</Text>
            </NameValuePair>
            <NameValuePair name={<Box direction='row'><MailOption color='brand'/><Text margin={{left: 'xsmall'}} size='small' weight={'bold'}>Contact Email</Text></Box>}>
            <Text size='small'>{lab.contact.contactEmail}</Text>
            </NameValuePair>
            <NameValuePair name={<Box direction='row'><Phone color='brand'/><Text margin={{left: 'xsmall'}} size='small' weight={'bold'}>Contact Phone</Text></Box>}>
            <Text size='small'>{lab.contact.contactPhone}</Text>
            </NameValuePair>
          </NameValueList>
         </Box> 
        ) 
    }
}

function AddressSummary(props){
    return (
        returnAddressDetails(props)  
    )
}

export default AddressSummary
